// Inbox and voucher catalog (English).
window.PlummeI18n.register('en', {
  'voucher.none': 'No vouchers',
  'voucher.noLedgerLines': 'No ledger lines available from the backend yet.',
  'voucher.noLedger': 'No ledger lines',
  'voucher.action': 'Action',
  'voucher.title': 'Transactions',
  'voucher.incompleteBasis': 'Journal coverage is incomplete. The list remains available for document lookup, but must not be treated as a complete general ledger or voucher list.',
  'voucher.journalLoading': 'The accounting journal is loading. Vouchers appear once it has been read.',
  'voucher.subtitle': 'All posted transactions for the financial year',
  'voucher.backToVat': 'Back to the VAT return',
  'voucher.showAll': 'Show all transactions',
  'voucher.download': 'Download',
  'voucher.loadingPreview': 'Loading preview...',
  'voucher.cannotPreviewUse': 'The file cannot be previewed here. Use Download when you want to open it.',
  'voucher.cannotPreview': 'This file type cannot be previewed here.',
  'voucher.invoice': 'Invoice',
  'voucher.voucher': 'Voucher',
  'voucher.attachmentAttached': 'Voucher attached',
  'voucher.commentOptional': 'Comment (optional)',
  'voucher.commentPh': 'E.g. wrong amount, double entry or wrong supplier.',
  'voucher.view': 'View',
  'voucher.viewHelp': 'Switch between the voucher list, detailed entries and the ledger grouped by account.',
  'voucher.view.bilag': 'Vouchers',
  'voucher.view.detaljer': 'Details',
  'voucher.view.hovedbok': 'Ledger',
  'voucher.searchPh': 'Search by voucher, account or amount',
  'voucher.searchHelp': 'Search by voucher number, counterparty, account/entry or amount. In the ledger view you can also search debit, credit and balance.',
  'voucher.filterHelp': 'Filter the vouchers by type, attachment, payment status, period and amount.',
  'voucher.amountTitle': 'Amount on the voucher',
  'voucher.amountHelp': 'Net is the amount excluding VAT (the cost or income itself), VAT is the tax, and gross is the total including VAT. Together with the date and voucher number these are the key details of the entry.',
  'voucher.rowHelp': 'Each row is one voucher. The icon and label show the type (sale, purchase, supplier invoice, credit note, manual voucher), and you see the name and voucher number. Tap the row to open the voucher.',
  'voucher.net': 'Net',
  'voucher.netHelp': 'The amount excluding VAT - the cost or income itself that is posted to an account.',
  'voucher.vat': 'VAT',
  'voucher.vatHelp': 'The VAT on the voucher - output VAT on sales, input (deductible) VAT on purchases.',
  'voucher.gross': 'Gross',
  'voucher.totalAmount': 'Total amount',
  'voucher.grossHelp': 'The total including VAT - net plus VAT. This is the amount actually paid or received.',
  'voucher.accountPh': 'E.g. software, bank or 6300',
  'voucher.account': 'Account',
  'voucher.accountHelp': 'The account tells you what the entry is for - taken from the chart of accounts. The account number decides where the amount ends up (1xxx assets, 2xxx liabilities/equity, 3xxx income, 4-7xxx costs). Tap the list icon to search the chart of accounts.',
  'voucher.pickAccount': 'Choose account',
  'voucher.searchChart': 'Search the chart of accounts...',
  'voucher.noDescription': 'No description',
  'voucher.removeEntry': 'Remove entry',
  'voucher.entryDate': 'Voucher date',
  'voucher.entryDateHelp': 'The date the entry should be posted on. It decides which accounting and VAT period the entry ends up in.',
  'voucher.whatFor': 'What is the entry for?',
  'voucher.whatForHelp': 'A short text explaining what the entry is for. It appears in the ledger and makes the entry easy to understand later.',
  'voucher.fromAccount': 'From account',
  'voucher.toAccount': 'To account',
  'voucher.fromAccountCredit': 'From account (credit)',
  'voucher.fromAccountHelp': 'The account the money comes FROM - the credit side of the entry. If you pay rent from the bank account, the bank (1920) is "From". A credit reduces an asset or increases a liability/income.',
  'voucher.vatCode': 'VAT code',
  'voucher.vatCodeHelp': 'The VAT code controls how VAT is calculated and reported on the VAT return. Code 86 is used for remotely deliverable services from abroad. Imports of goods are recorded through the customs declaration flow.',
  'voucher.swap': 'Swap From and To',
  'voucher.swapHelp': 'Swaps the From and To account on the line. Useful if you have entered debit and credit the wrong way round.',
  'voucher.toAccountDebit': 'To account (debit)',
  'voucher.toAccountHelp': 'The account the money goes TO - the debit side of the entry. If the entry is for rent, the rent account (6300) is "To". A debit increases a cost or an asset.',
  'voucher.addLineHelp': 'Adds a new entry line to this voucher. Use several lines when the amount is split across accounts - all lines together must make debit and credit net to zero.',
  'voucher.attachHelp': 'Attach documentation for the entry - a receipt, invoice or other voucher. Optional but recommended: good documentation makes the accounts verifiable. You can drag in files or paste a screenshot.',
  'voucher.attachOptional': 'Attachments (optional)',
  'voucher.uploadAttachment': 'Upload attachment',
  'voucher.deleteAttachment': 'Delete attachment',
  'voucher.openNewTab': 'Open in a new tab',
  'voucher.balance': 'Balance',
  'voucher.balanceHelp': 'Shows whether the entry balances. "Balanced" means the To (debit) total equals the From (credit) total - then the entry can be posted. If there is a difference, correct the amounts so they net to zero.',
  'voucher.toDebit': 'To (debit)',
  'voucher.fromCredit': 'From (credit)',
  'voucher.posted': 'Posted',
  'voucher.edit': 'Edit',
  'voucher.newCopy': 'New copy of manual entry',
  'voucher.newFree': 'New manual entry',
  'voucher.from': 'From',
  'voucher.to': 'To',
  'voucher.sum': 'Total',
  'voucher.newEntry': 'New entry',
  'voucher.newEntryHelp': 'Adds another entry (a new voucher) under the same registration. Each entry has its own date, description and lines, and is posted as its own voucher.',
  'voucher.postHelp': 'Posts the entries in the accounts. The button becomes active only once every entry balances - that is, debit and credit net to zero.',
  'voucher.details': 'Details',
  'voucher.statusBalanced': 'Balanced',
  'voucher.statusMissingAccount': 'Missing account',
  'voucher.statusSameAccount': 'Same account',
  'voucher.statusEmpty': 'Empty',
  'voucher.statusUnbalanced': 'Unbalanced',
  'voucher.attachDropHint': 'Drag and drop files here, or paste a screenshot with Ctrl+V',
  'voucher.chooseBothAccounts': 'Choose both the from and to account.',
  'voucher.sameAccountWarning': 'The from and to account cannot be the same account.',
  'voucher.balancedReady': 'Balanced - ready to register',
  'voucher.enterAmount': 'Enter an amount.',
  'voucher.difference': 'Difference: {amount}',
  'voucher.postedTitlePlural': 'Entries registered',
  'voucher.postedTitleSingular': 'Entry registered',
  'voucher.postedBodyPlural': '{count} entries have been posted.',
  'voucher.postedBodySingular': 'The entry has been posted.',
  'voucher.postedIntro': 'Here is how it was posted:',
  'voucher.descriptionRequired': 'Enter a description on all entries before posting.',
  'voucher.saveFailed': 'Could not register the entry.',
  'voucher.backTo': 'Back to {label}',
  'voucher.controlPoint': 'the control point',
  'voucher.editTitle': 'Edit free posting',
  'voucher.freePosting': 'Free posting',
  'voucher.editSubtitle': 'Update the entry and save the changes to the backend.',
  'voucher.correctPostedTitle': 'Correct posted voucher',
  'voucher.correctPostedSubtitle': 'The original is preserved. Plumme posts a reversal and a replacement voucher in one operation.',
  'voucher.correctPostedNotice': 'The original voucher and journal number remain unchanged. The change is recorded as a linked reversal and replacement.',
  'voucher.correctionReason': 'Correction reason',
  'voucher.correctionReasonPlaceholder': 'Describe what was wrong and why the voucher is being corrected',
  'voucher.correctPostedAction': 'Correct voucher',
  'voucher.correctionPreview': 'Preview correction',
  'voucher.correctionOriginal': 'Original',
  'voucher.correctionReversal': 'Exact reversal',
  'voucher.correctionReplacement': 'Replacement voucher',
  'voucher.freePostingSubtitle': 'Manual entries - debit and credit must net to zero',
  'voucher.freePostingTitleHelp': 'Free posting lets you post manually straight to an account when you need full control - for example corrections, reclassifications, or entries that do not fit a regular purchase or sale. You choose which accounts the amount moves between.',
  'voucher.directVatWarningTitle': 'Warning: direct posting to a VAT account',
  'voucher.directVatWarningBody': 'These entries are posted to the general ledger but are excluded from the VAT return. Use the regular purchase, sale, or customs declaration flow when the amount must be reported as VAT.',
  'voucher.directVatExcluded': 'excluded from the VAT return',
  'voucher.directVatConfirmLabel': 'Type OK to confirm that you understand the consequence',
  'voucher.directVatConfirmValue': 'OK',
  'voucher.registerEntriesPlural': 'Register entries',
  'voucher.registerEntrySingular': 'Register entry',
  'voucher.registering': 'Registering...',
  'voucher.creditWord': 'credit',
  'voucher.debitWord': 'debit',
  'voucher.attachmentFallbackName': 'attachment',
  'inbox.prevPage': 'Previous page',
  'inbox.page': 'Page',
  'inbox.nextPage': 'Next page',
  'inbox.zoomOut': 'Zoom out',
  'inbox.zoomIn': 'Zoom in',
  'inbox.rotate': 'Rotate receipt',
  'inbox.mainDoc': 'Main receipt',
  'inbox.moveTo': 'Move to',
  'inbox.payOperating': 'Operating account - 1920',
  'inbox.payCash': 'Cash - 1900',
  'inbox.payPrivate': 'Private expense',
  'inbox.payUnknown': 'Choose payment source ...',
  'inbox.suggestion': 'Suggestion from SuperPlumma',
  'inbox.docType': 'Voucher type',
  'inbox.quickChoices': 'Quick choices',
  'inbox.quickChoiceUse': 'Choose what the quick choice should replace',
  'inbox.quickChoiceRemembered': 'Remembered from {count} previous supplier vouchers.',
  'inbox.quickChoiceAccount': 'Replace account',
  'inbox.quickChoiceDescription': 'Replace description',
  'inbox.quickChoiceBoth': 'Replace both',
  'inbox.purchase': 'Purchase',
  'inbox.supplierInvoice': 'Supplier invoice',
  'inbox.pickSupplier': 'Choose supplier',
  'inbox.invoiceNoPh': 'E.g. 0012345',
  'inbox.toggleVatHelp': 'Tap to switch whether the amount you enter is excluding or including VAT. Plumme converts automatically and stores the gross amount on the voucher suggestion.',
  'inbox.vatDeductionRate': 'Suggested VAT deduction',
  'inbox.documentVatRateHint': 'The document shows {documentRate}% VAT. The suggestion uses a {deductionRate}% deduction based on the business VAT status and selected treatment.',
  'inbox.accountCategory': 'Account/category',
  'inbox.accountHelp': 'The SuperPlumma suggestion is preselected. Tap to choose a different account.',
  'inbox.dueDateFromReceipt': 'The document has no due date. Set to the document date.',
  'inbox.supplierNotSaved': 'Select a saved supplier, or save the supplier before posting the invoice.',
  'err.purchase.supplierNotSaved': 'Select a saved supplier, or save the supplier before posting the invoice.',
  'inbox.duplicateTitle': 'Possible duplicate',
  'inbox.duplicateBody': 'A voucher with the same date and amount is already posted.',
  'inbox.duplicateSameSupplier': 'A voucher with the same date, amount and supplier is already posted.',
  'inbox.duplicateUploadFile': 'Possible duplicate upload: the exact same file is already in the inbox.',
  'inbox.duplicateUploadContent': 'Possible duplicate upload: same supplier and amount as another voucher in the inbox, with voucher dates within 7 days.',
  'inbox.duplicateUploadCount': 'Applies to {count} other vouchers.',
  'inbox.setPaymentSource': 'Paid from',
  'inbox.bulkPaymentTitle': 'Paid from',
  'inbox.bulkPaymentLead': 'The source is set on {count} documents. You can change it per document afterwards.',
  'inbox.bulkPaymentLabel': 'Paid from',
  'inbox.bulkPaymentHint': 'The documents become ready to post with this account.',
  'inbox.bulkPaymentPick': 'Pick a payment source first.',
  'inbox.bulkPaymentConfirm': 'Set on {count} documents',
  'inbox.bulkPaymentDone': 'Payment source set on {count} documents.',
  'inbox.uploadPaymentSingleTitle': 'Paid from',
  'inbox.uploadPaymentBulkTitle': 'Assign payment sources',
  'inbox.uploadPaymentAppliesTo': 'Applies to {count} selected receipts',
  'inbox.uploadPaymentSelectFirst': 'Select receipts below, and the buttons set their payment source.',
  'inbox.uploadPaymentBank': 'Bank',
  'inbox.uploadPaymentBankSetup': 'Add a bank account first',
  'inbox.uploadPaymentOtherSource': 'Choose another payment source ...',
  'inbox.uploadPaymentOperating': 'Operating account',
  'inbox.uploadPaymentPrivate': 'Private',
  'inbox.uploadPaymentPrivateRecommended': 'Recommended without a business account',
  'inbox.uploadPaymentAnalyzeShort': 'Superplumma analyses',
  'inbox.collectionNotice': 'Collection notice',
  'inbox.collectionNoticeTitle': 'This belongs with the original document',
  'inbox.collectionNoticeBody': 'Do not book the principal or its VAT again. Link the notice to the original document; handle interest and collection costs separately without VAT.',
  'inbox.collectionNoticePrincipal': 'Principal',
  'inbox.collectionNoticeInterest': 'Interest',
  'inbox.collectionNoticeCosts': 'Collection costs',
  'inbox.collectionNoticeCandidates': 'Possible original documents',
  'inbox.collectionNoticeLink': 'Link',
  'inbox.collectionNoticeLinked': 'The collection notice is linked to the original document.',
  'inbox.collectionNoticeLinkFailed': 'Could not link the collection notice to the original document.',
  'inbox.collectionNoticeOpenOriginal': 'Open original document',
  'inbox.collectionNoticeNoCandidate': 'No safe match was found. Find or upload the original invoice before processing the notice.',
  'inbox.collectionNoticeBookBlocked': 'Link the original document before processing',
  'inbox.uploadPaymentAssigned': 'Account {account}',
  'inbox.uploadPaymentUnpaid': 'Not paid yet',
  'inbox.uploadPaymentUnpaidHint': 'For a supplier invoice that should remain payable until it is paid.',
  'inbox.uploadPaymentAnalyze': 'Let Plumme find the payment source',
  'inbox.uploadPaymentUnassigned': 'Not assigned',
  'inbox.uploadPaymentSelectVisible': 'Select shown',
  'inbox.uploadPaymentShowAll': 'Show all',
  'inbox.uploadPaymentShowPending': 'Show only unassigned',
  'inbox.uploadPaymentProgress': '{completed} of {count} assigned',
  'inbox.uploadPaymentConfirm': 'Upload {count}',
  'inbox.uploadPaymentReceipt': 'Document',
  'inbox.cardNudgeTitle': '{count} documents have no payment source',
  'inbox.cardNudgeText': 'Register your cards on the bank accounts and Plumme recognises the payment straight from the receipt. The account type decides company or private outlay.',
  'inbox.cardNudgeAction': 'Register cards',
  'inbox.shortDescription': 'Short description of the voucher',
  'inbox.shrinkPreview': 'Shrink preview',
  'inbox.growPreview': 'Enlarge preview',
  'inbox.dragWidth': 'Drag to change the width',
  'inbox.sendTo': 'Send to:',
  'inbox.filterStatus': 'Status',
  'inbox.filterBankConnection': 'Bank connection',
  'inbox.filterReadyToPost': 'Ready to post',
  'inbox.filterNeedsReview': 'Needs review',
  'inbox.filterAwaitingAnalysis': 'Waiting for analysis',
  'inbox.toInbox': 'To Inbox (vouchers)',
  'inbox.toDocumentation': 'To documentation',
  'inbox.selectAll': 'Select all',
  'inbox.selectHint': 'Shift-click to select a range',
  'inbox.reviewSelected': 'Start posting ({count})',
  'inbox.planTitle': 'Post with SuperPlumma',
  'inbox.planLead': '{count} of {selected} selected documents will be posted now.',
  'inbox.planNothing': 'None of the selected documents can be posted as they stand.',
  'inbox.planWithNotes': '{count} with a preselected payment source',
  'inbox.planConfirm': 'Post {count} documents',
  'inbox.planShow': 'Show',
  'inbox.planHide': 'Hide',
  'inbox.planSameFile': 'Blocked: the exact same file is already here ({count})',
  'inbox.planSameInvoiceNumber': 'Blocked: the invoice number is already registered ({count})',
  'inbox.planSameContent': 'Skipped: possible duplicate upload ({count})',
  'inbox.planNeedsReview': 'Skipped: needs review ({count})',
  'inbox.planMissingData': 'Skipped: missing data ({count})',
  'inbox.planMissing': 'Skipped: no longer in the inbox ({count})',
  'inbox.planAllowContent': 'Post these anyway - I have checked that they are separate purchases',
  'inbox.planAllowContentWarn': 'The duplicates will be posted as separate documents. Check before you continue.',
  'inbox.planResultTitle': 'Posting finished',
  'inbox.planResultLead': '{booked} of {selected} selected documents were posted.',
  'inbox.planBooked': 'Posted ({count})',
  'inbox.planSkipped': 'Skipped ({count})',
  'inbox.planFailed': 'Failed ({count})',
  'inbox.walkTitle': 'Posting documents',
  'inbox.walkLead': '{count} documents in the queue.',
  'inbox.walkReady': 'Ready',
  'inbox.walkNeedsReview': 'Needs review',
  'inbox.walkDuplicates': 'Possible duplicates',
  'inbox.walkDuplicateOf': 'Same as {names}.',
  'inbox.walkHint': 'You can close at any time - whatever you have not handled stays selected.',
  'inbox.walkStart': 'Review all {count}',
  'inbox.walkBookReady': 'Post the {count} ready now',
  'inbox.walkPosition': '{index} of {total}',
  'inbox.walkPause': 'Continue later',
  'inbox.walkTrash': 'To trash',
  'inbox.walkSkip': 'Skip',
  'inbox.walkNext': 'Next',
  'inbox.walkGone': 'The document is gone',
  'inbox.walkGoneText': 'It was posted, deleted or moved while the review was open.',
  'inbox.walkDoneTitle': 'Review finished',
  'inbox.walkDoneLead': '{count} documents reviewed',
  'inbox.walkDoneCounts': '{booked} posted, {skipped} skipped, {trashed} moved to trash.',
  'inbox.clearSelection': 'Clear selection',
  'inbox.restoreAll': 'Restore all',
  'inbox.deletePermanently': 'Delete permanently',
  'inbox.deleteAll': 'Delete all',
  'inbox.downloadAll': 'Download selected',
  'inbox.downloading': 'Downloading...',
  'inbox.postAllWithAi': 'Post all with SuperPlumma',
  'inbox.postWithAi': 'Post {count} with SuperPlumma',
  'inbox.postNoneReady': 'None of the selected documents are ready to post. Use «Start posting» to take them one at a time.',
  'inbox.uploadDocument': 'Upload document',
  'inbox.mergeToOne': 'Merge into one voucher',
  'inbox.dragToMerge': 'Drag to merge vouchers',
  'inbox.restore': 'Restore',
  'inbox.post': 'Post',
  'inbox.archiveNote': 'An archive for documents that should not be posted as vouchers.',
  'inbox.searchDocs': 'Search documents...',
  'inbox.moveToTrash': 'Move to trash',
  'inbox.defaultVoucherName': 'Voucher',
  'inbox.defaultDocumentName': 'Document',
  'inbox.docTypeSettlement': 'Settlement',
  'inbox.docTypeSupplierInvoice': 'Supplier invoice',
  'inbox.docTypeSaleVoucher': 'Sales voucher',
  'inbox.docTypePurchaseVoucher': 'Purchase voucher',
  'inbox.paySourcePrivate': 'Paid privately',
  'inbox.paySourceCash': 'Cash',
  'inbox.paySourceUnclear': 'Unclear payment',
  'inbox.paySourceCompany': 'Company account',
  'inbox.vatOnDocumentWithDeduction': '{documentRate} % VAT on the voucher · {deductionRate} % deduction',
  'inbox.vatRateLabel': '{rate} % VAT',
  'inbox.paidFromBank': 'Paid from bank',
  'inbox.supplierNotRead': 'Supplier not read',
  'inbox.invoiceNumberLabel': 'Invoice {number}',
  'inbox.attachmentLinkMissing': 'The attachment has no available link.',
  'inbox.menuNewPurchase': 'Paid purchase',
  'inbox.menuFixedAsset': 'Fixed asset',
  'inbox.menuOtherSale': 'Other sale',
  'inbox.menuOpenAttachment': 'Open attachment',
  'inbox.menuDownload': 'Download',
  'inbox.menuSplitAgain': 'Split again',
  'inbox.reanalyze': 'Re-analyze',
  'inbox.analyze': 'Analyze',
  'inbox.previewDocumentFallback': 'Document',
  'inbox.previewMissingFileLink': 'Missing file link',
  'inbox.saveNotConnected': 'Saving the voucher suggestion is not connected to the backend.',
  'inbox.suggestionUpdated': 'The voucher suggestion has been updated.',
  'inbox.suggestionSaveFailed': 'Could not save the voucher suggestion.',
  'inbox.settlementFromLabel': 'Settlement from',
  'inbox.settlementFromPh': 'Vipps, Stripe, Klarna ...',
  'inbox.settlementIdLabel': 'Settlement ID',
  'inbox.settlementNetToBankLabel': 'Net to bank',
  'inbox.suggestedInvoiceSingular': 'Suggested invoice',
  'inbox.suggestedInvoicePlural': 'Multiple possible invoices',
  'inbox.selectInvoiceManually': 'Choose invoice manually',
  'inbox.paidToggleOn': 'Paid',
  'inbox.paidToggleOff': 'Not paid – recorded as accounts payable',
  'inbox.paidToLabel': 'Paid to',
  'inbox.projectSaveFailed': 'Could not save the project.',
  'inbox.awaitingOcrData': 'Awaiting OCR data',
  'inbox.showSuggestionAgain': 'Show suggestion again',
  'inbox.maximizePreview': 'Maximize preview',
  'inbox.uploadPartialAnalyzing': '{done} of {total} vouchers were uploaded. Analyzing the ones that came in ...',
  'inbox.uploadedSingle': 'Voucher uploaded.',
  'inbox.uploadedMultipleAnalyzing': '{count} vouchers uploaded. Analyzing ...',
  'inbox.uploadFailedSingle': 'Could not upload the voucher.',
  'inbox.uploadFailedMultiple': 'Could not upload the vouchers.',
  'inbox.uploadFailedGeneric': 'Could not upload vouchers.',
  'inbox.remainingAwaitingAnalysisSuffix': '{count} vouchers remain as "Awaiting analysis".',
  'inbox.uploadedButAnalysisFailedSingle': 'The voucher was uploaded, but the analysis failed.',
  'inbox.uploadedButAnalysisFailedMultiple': 'The vouchers were uploaded, but the analysis failed.',
  'inbox.partialAnalysisFailed': '{failed} of {total} vouchers were not analyzed. Try "Analyze" on the row.',
  'inbox.documentAddedSingle': 'Document added to Documentation.',
  'inbox.documentAddedMultiple': 'Documents added to Documentation.',
  'inbox.documentUploadFailed': 'Could not upload the document.',
  'inbox.analyzed': 'The voucher has been analyzed.',
  'inbox.analyzeActionFailed': 'The voucher analysis failed.',
  'inbox.bookedNoneReason': 'No vouchers were posted.',
  'inbox.bookedSummary': '{booked} posted, {skipped} skipped.',
  'inbox.bookedOne': 'The voucher has been posted.',
  'inbox.bookedCount': '{count} vouchers posted.',
  'inbox.bookFailedFallback': 'Could not post the vouchers.',
  'inbox.setPaymentSourceFailed': 'Could not set the payment source.',
  'inbox.moveToTrashFailed': 'Could not move the voucher(s) to trash.',
  'inbox.movedToTrash': 'Voucher moved to trash.',
  'inbox.movedToTrashCount': '{count} vouchers moved to trash.',
  'inbox.restoredOne': 'Voucher restored.',
  'inbox.restoredCount': '{count} vouchers restored.',
  'inbox.restoreFailed': 'Could not restore the voucher(s).',
  'inbox.confirmDeletePermanentOne': 'Delete the voucher permanently?',
  'inbox.confirmDeletePermanentMany': 'Delete the selected vouchers permanently?',
  'inbox.deletedPermanently': 'Voucher deleted permanently.',
  'inbox.deleteFailed': 'Could not delete the voucher(s).',
  'inbox.docMovedToTrash': 'Document moved to trash.',
  'inbox.docMovedToTrashCount': '{count} documents moved to trash.',
  'inbox.docMoveToTrashFailed': 'Could not move the document(s) to trash.',
  'inbox.docRestored': 'Document restored.',
  'inbox.docRestoredCount': '{count} documents restored.',
  'inbox.docRestoreFailed': 'Could not restore the document(s).',
  'inbox.confirmDeleteDocOne': 'Delete the document permanently?',
  'inbox.confirmDeleteDocMany': 'Delete the selected documents permanently?',
  'inbox.docDeletedPermanently': 'Document deleted permanently.',
  'inbox.docDeleteFailed': 'Could not delete the document(s).',
  'inbox.downloadPartial': '{downloaded} of {total} files were downloaded. The rest could not be retrieved.',
  'inbox.downloadedZip': '{count} files downloaded as a zip.',
  'inbox.downloadedSingleFile': 'The file has been downloaded.',
  'inbox.downloadFilesFailed': 'Could not download the files.',
  'inbox.movedToDocs': 'Voucher moved to Documentation.',
  'inbox.movedToDocsCount': '{count} vouchers moved to Documentation.',
  'inbox.moveToDocsFailed': 'Could not move the voucher(s) to Documentation.',
  'inbox.mergedCount': '{count} vouchers merged.',
  'inbox.mergeFailed': 'Could not merge the vouchers.',
  'inbox.splitAgainDone': 'The voucher has been split again.',
  'inbox.splitAgainFailed': 'Could not split the voucher.',
  'inbox.addressCopied': 'Voucher address copied.',
  'inbox.trashTitle': 'Trash',
  'inbox.docsSubtitle': 'Archive for agreements, contracts and documents - not vouchers for posting.',
  'inbox.inboxSubtitle': 'Upload or forward vouchers by email - we read what we can.',
  'inbox.titleHelp': 'The inbox is where vouchers land once they arrive but before they are posted. Upload files or forward receipts and invoices by email - SuperPlumma reads the content and gets them ready for posting.',
  'inbox.docsWithCount': 'Documentation ({count})',
  'inbox.trashWithCount': 'Trash ({count})',
  'inbox.inboxWithCount': 'Inbox ({count})',
  'inbox.wordDocuments': 'documents',
  'inbox.wordVouchers': 'vouchers',
  'inbox.emptyDocsTitle': 'No documents',
  'inbox.emptyTrashTitle': 'The trash is empty',
  'inbox.emptyDocsText': 'Upload agreements, contracts and documents here.',
  'inbox.searchDocsFull': 'Search documents - file name, type...',
  'inbox.vehicleCostReminderDefault': 'Only if the business owns or leases a vehicle.',
});
